/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */

import {
  ImageElement,
} from "utils";
import { Container, Row, Col } from "react-bootstrap";
import CapturedModel from "components/UiElement/Theme01/CapturedModel";
import { RippleEffect, Loader, CommonButton } from "components";

function CapturedSection({ showImageModal,
  capturedData,
  openModal,
  handleCloseModalImageMemory,
  imageData,
  loading,
  count,
  onShowMore,
}) {
  return (
    <>
      <section className="preservingSec py-80 light-bg" id="gallery">
        <Container>
          <div className="commonHead text-center">
            <div className="commonHead_sub">
              Photographs- Videos- Other Media
            </div>
            <h2 className="commonHead_title">Captured Memories</h2>
          </div>
          <div className="preservingSec_inner">

            <Row>
              {capturedData?.length > 0 && capturedData.map((item) => (
                <Col xs={6} sm={6} md={4}>
                  <div className="box" onClick={() => showImageModal(item?.id)}>
                    <div className="box_img">
                      <ImageElement
                        previewSource={item?.memorialAlbumImageUrl}
                        className="object-fit-cover w-100 h-100"
                        alt="timeline-img"
                      />
                    </div>
                    <h4 className="text-break">
                      {item?.name}
                    </h4>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
        <CapturedModel
          handleCloseModal1={handleCloseModalImageMemory}
          showModal1={openModal}
          photoData={imageData}
        />
        <RippleEffect extraClassName="justify-content-center mt-sm-3 w-100 py-1">
          <div className="text-center">
            {loading ? (
              <Loader />
            ) : (
              count > capturedData?.length && (
                <CommonButton
                  variant="light"
                  onClick={(e) => {
                    e.preventDefault();
                    onShowMore();
                  }}
                >
                  Load More
                </CommonButton>
              )
            )}
          </div>
        </RippleEffect>
      </section>

    </>
  );
}

export default CapturedSection;
